export enum EPurpose {
  /// <summary>
  /// 출입구
  /// </summary>
  ENTRANCE = 1,
  /// <summary>
  /// 출구
  /// </summary>
  EXIT,
  /// <summary>
  /// 안티패스 출입구 (삭제 요망)
  /// </summary>
  APB_ENTRANCE,
  /// <summary>
  /// 안태패스 출구 (삭제 요망)
  /// </summary>
  APB_EXIT,
  /// <summary>
  /// 식당
  /// </summary>
  RESTAURANT = 5,

  /// <summary>
  /// 에스코트 입문
  /// </summary>
  ESCORT_ENTRANCE = 0x11,
  /// <summary>
  /// 에스코트 출문
  /// </summary>
  ESCORT_EXIT
}
